import React from 'react';
import { CalendarInputCommonProps, CalendarPresetItem } from './types';
import styled from '@emotion/styled';
import { colors, semantic_colors, shapes, text_styles } from '../../../foundation';
import { Stack } from '../../stack';
import { usePresetList } from './hooks/usePresetList';

export interface PresetListProps extends CalendarInputCommonProps {
  presets?: CalendarPresetItem[];
  shouldConfirm?: boolean;
}

export const PresetList: React.FC<PresetListProps> = ({ ...props }) => {
  const items = usePresetList(props);
  return (
    <StyledDatePresetContainer direction='column'>
      {items.map((preset, index) => (
        <StyledPresetButton key={index} checked={preset.selected} disabled={preset.disabled} onClick={preset.onClick}>
          {preset.label}
        </StyledPresetButton>
      ))}
    </StyledDatePresetContainer>
  );
};

const StyledDatePresetContainer = styled(Stack)`
  border-right: 1px solid ${semantic_colors.border.primary};
  padding: 8px;
`;

const StyledPresetButton = styled.label<{ checked: boolean; disabled: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 8px 12px;
  cursor: pointer;
  width: 80px;
  height: 38px;
  vertical-align: middle;
  white-space: nowrap;
  outline: none;
  ${text_styles.Body_13_Regular};
  ${shapes.border_radius.xsmall};
  transition: all 0.1s linear;
  ${({ checked }) =>
    checked
      ? `
          background-color: ${semantic_colors.accent.primary};
          color: ${semantic_colors.content.primary_inverse};
          &:hover, &:active {
            background-color: ${semantic_colors.accent.primary};
          }
        `
      : `
          background-color: ${semantic_colors.background.surface};
          color: ${semantic_colors.content.primary};
          &:hover {
            background-color: ${semantic_colors.accent.light};
          }
          &:active {
            background-color: ${colors.blue100};
          }
        `};

  input[type='radio'] {
    display: none;
  }
  ${({ disabled }) =>
    disabled &&
    `
    color: ${semantic_colors.content.disabled};
    cursor: not-allowed;
    &:hover,
    &:active {
      background-color: ${semantic_colors.background.surface};
    }
  `}
`;
